// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"03e5b9d0","453":"c236b0ab","589":"6b100b38","597":"ceb21a12"}[chunkId] + ".chunk.js";
};